/**
 * Coure.Hub.Service.Creation
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { StringStringKeyValuePair } from './stringStringKeyValuePair';

export interface AutomatedMessageData { 
    isAutoReplyActivated?: boolean;
    subscriptionKeyword?: string;
    autoResponseToSubscriptionKeyword?: string;
    autoResponseToUnSubscriptionKeyword?: string;
    unSubscriptionKeyword?: string;
    helpKeyword?: string;
    autoResponseToHelpKeyword?: string;
    autoResponseMessageAndKeywords?: Array<StringStringKeyValuePair>;
    createdAt?: Date;
}